import React from 'react';
import moment from 'moment';
import { Box, Grid, Stack, Typography } from '@mui/material';
import ChatMessageAction from './ChatMessageAction';
import Reply from './Reply';
import AttachmentFileDownload from './AttachmentFileDownload';
import ImageViewer from './ImageViewer';

const MessageR = ({ message, date, image, file, msgObj }) => {
	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start">
				<Grid container justifyContent="flex-end" sx={{ mt: '3px' }}>
					<Grid item xs={2} md={3} xl={4} />

					<Grid item xs={10} md={9} xl={8}>
						<Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1.25}>
							<ChatMessageAction messageObj={msgObj} date={date} direction="RIGHT" />
							<Box
								sx={{
									display: 'inline-block',
									wordWrap: 'break-word',
									whiteSpace: 'pre-wrap',
									float: 'right',
									bgcolor: '#4169E1',
									color: 'common.white',
									borderRadius: '6px',
									p: '9px 12px 9px 12px',
								}}
							>
								{image && <ImageViewer file={image} />}
								{file && <AttachmentFileDownload attachment={file} />}

								<Box>
									<Typography variant="chat" sx={{ overflowWrap: 'anywhere' }}>
										{message}
									</Typography>
									<Typography variant="date" sx={{ visibility: 'hidden', pl: 1 }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
								<Box
									sx={{
										display: 'inline-block',
										float: 'right',
										lineHeight: '10px',
										marginBottom: '-8px',
										marginRight: '-5px',
										marginTop: '-10px',
									}}
								>
									<Typography variant="date" component="span" align="right" sx={{ color: 'white' }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Stack>
		</Grid>
	);
};

export default MessageR;

export const DeleteMessageR = ({ date }) => {
	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start" spacing={1.25}>
				<Grid container spacing={0.5} justifyContent="flex-end">
					<Grid item xs={2} md={3} xl={4} />

					<Grid item xs={10} md={9} xl={8}>
						<Stack direction="row" justifyContent="flex-end" alignItems="flex-start">
							<Box
								sx={{
									display: 'inline-block',
									wordWrap: 'break-word',
									whiteSpace: 'pre-wrap',
									float: 'right',
									bgcolor: '#9090902b',
									color: '#909090',
									borderRadius: '6px',
									p: '9px 12px 9px 12px',
								}}
							>
								<Box>
									<Typography variant="chat" sx={{ overflowWrap: 'anywhere' }}>
										You deleted this message
									</Typography>
									<Typography variant="date" sx={{ visibility: 'hidden', pl: 1 }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
								<Box
									sx={{
										display: 'inline-block',
										float: 'right',
										lineHeight: '10px',
										marginBottom: '-8px',
										marginRight: '-5px',
										marginTop: '-10px',
									}}
								>
									<Typography variant="date" component="span" align="right">
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Stack>
		</Grid>
	);
};

export const ReplyMessageR = ({ message, date, reply, replyUserName, replyMessage, msgObj }) => {
	return (
		<Grid item xs={12}>
			<Stack direction="row" alignItems="flex-start">
				<Grid container justifyContent="flex-end" sx={{ mt: '3px' }}>
					<Grid item xs={2} md={3} xl={4} />

					<Grid item xs={10} md={9} xl={8}>
						<Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1.25}>
							<ChatMessageAction messageObj={msgObj} date={date} direction="RIGHT" />
							<Box
								sx={{
									display: 'inline-block',
									wordWrap: 'break-word',
									whiteSpace: 'pre-wrap',
									float: 'right',
									bgcolor: '#4169E1',
									color: 'common.white',
									borderRadius: '6px',
									p: '9px 12px 9px 12px',
								}}
							>
								<Reply replyObj={reply} replyUserName={replyUserName} replyMessage={replyMessage} />
								<Box>
									<Typography variant="chat" sx={{ overflowWrap: 'anywhere' }}>
										{message}
									</Typography>
									<Typography variant="date" sx={{ visibility: 'hidden', pl: 1 }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
								<Box
									sx={{
										display: 'inline-block',
										float: 'right',
										lineHeight: '10px',
										marginBottom: '-8px',
										marginRight: '-5px',
										marginTop: '-10px',
									}}
								>
									<Typography variant="date" component="span" align="right" sx={{ color: 'white' }}>
										{date && moment(date).format('LT')}
									</Typography>
								</Box>
							</Box>
						</Stack>
					</Grid>
				</Grid>
			</Stack>
		</Grid>
	);
};
